<script setup lang="ts">
type Props = {
  noteHtml: string;
}

const props = defineProps<Props>();
</script>
<template>
  <div class="w-full max-w-[100%] p-4 bg-[var(--apx-note-background-color)]">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="note-viewer" v-html="props.noteHtml" />
  </div>
</template>
<style scoped>
:deep(.note-viewer) {
  ul {
    margin-top: 1.25rem;
    list-style: disc inside;
    line-height: normal;
  }
}

:deep(.note-viewer) {
  ol {
    margin-top: 1.25rem;
    list-style: decimal inside;
    line-height: normal;
  }
}

:deep(.note-viewer) {
  max-width: 100%;
  overflow-wrap: anywhere;

  p {
    margin-bottom: 1.25rem;
  }
}
</style>
